const intercomConfig = {
	RSM_ARTICLE_ID: process.env.VUE_APP_RSM_ARTICLE_ID || '9456983',
}

export default intercomConfig
